<template>
  <div
    class="c-beginnerBanners"
    :class="rootClass()"
    v-if="isShown"
  >
    <a
      class="c-beginnerBanner"
      href="/pages/about"
    >
      <img
        class="c-beginnerBanner_beginerImage"
        src="~/assets/images/components/BeginnerBanners/banner-beginer.png"
        alt="はじめての方へ"
        loading="lazy"
        decoding="async"
      >
      <img
        class="c-beginnerBanner_beginerImage c-beginnerBanner_beginerImage-sp"
        src="~/assets/images/components/BeginnerBanners/banner-sp-beginer.png"
        alt="はじめての方へ"
        loading="lazy"
        decoding="async"
      >
    </a>

    <NuxtLink
      class="c-beginnerBanner"
      to="/business/?ref=banner"
    >
      <img
        class="c-beginnerBanner_enterpriseImage"
        src="~/assets/images/components/BeginnerBanners/banner-business.png"
        alt="coconala Business"
        loading="lazy"
        decoding="async"
      >
      <img
        class="c-beginnerBanner_enterpriseImage c-beginnerBanner_enterpriseImage-sp"
        src="~/assets/images/components/BeginnerBanners/sp-banner-business.png"
        alt="coconala Business"
        loading="lazy"
        decoding="async"
      >
    </NuxtLink>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/** @type {import('vue').ComponentOptions} */
const beginnerBanners = {
  name: 'BeginnerBanners',
  props: {
    targetDevice: {
      type: String,
      default: 'ALL',
      validator(v) {
        return ['ALL', 'PC', 'SP'].includes(v)
      }
    }
  },
  computed: {
    ...mapState('auth/user', ['isBusiness']),
    isShown() {
      return !this.isBusiness && !this.$route.query.is_business
    }
  },
  methods: {
    rootClass() {
      return `c-beginnerBanners-${this.targetDevice.toLowerCase()}`
    }
  }
}
export default beginnerBanners
</script>

<style lang="scss" scoped>
.c-beginnerBanners {
  display: flex;
  margin-top: 20px;
  &-sp {
    display: none;
  }
}

.c-beginnerBanner {
  @include link-effect;

  position: relative;
  width: 100%;
  &:nth-child(n + 2) {
    margin-left: 20px;
  }
  &::before {
    display: block;
    // PC用バナーの高さ: バナー横幅 * 画像のアスペクト比
    padding-top: calc(100% * 13 / 59);
    content: '';
  }
  &_beginerImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &-sp {
      display: none;
    }
  }
  &_enterpriseImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &-sp {
      display: none;
    }
  }
}

@media (max-width: breakpoint(Home, M)) {
  .c-beginnerBanners {
    margin-top: 12px;

    justify-content: center;
    &-pc {
      display: none;
    }
    &-sp {
      display: flex;
    }
  }
  .c-beginnerBanner {
    &::before {
      // SP用バナーの高さ: バナー横幅 * 画像のアスペクト比
      padding-top: calc(100% * 19 / 71);
    }
    &:nth-child(n + 2) {
      margin-top: 0;
      margin-left: 20px;
    }
    &_beginerImage {
      display: none;
      &-sp {
        display: block;
      }
    }
    &_enterpriseImage {
      display: none;
      &-sp {
        display: block;
      }
    }
  }
}
@media (max-width: $breakpoint-s) {
  .c-beginnerBanners {
    flex-direction: column;

    align-items: center;
  }
  .c-beginnerBanner {
    &:nth-child(n + 2) {
      margin-top: 12px;
      margin-left: 0;
    }
  }
}
</style>
